import { B_AttrFlags } from "./model/BBase";

function inEachArray(container, fn) {
	if (container) {
		for (const i in container) if(Object.hasOwn(container, i)) {
			const a = container[i];

			if (Array.isArray(a)) { fn(a); }
		}
	}
}

function getEditorColor(b_item) {
	let polygonColor = "#000";
	if (b_item.getFloor) {
		const flr = b_item.getFloor();
		if (flr) {
			polygonColor = flr.getEditorColorAsCSS(void(0), (is_outer(b_item) || is_open(b_item)) ? 1 : 0.25);
		}
	}

	return polygonColor;
}

function is_outer(bitem) {
	return (bitem.flags & B_AttrFlags.BuildingOuter) !== 0;
}

function is_open(bitem) {
	return (bitem.flags & B_AttrFlags.OpenRing) !== 0;
}


function addToMapIf(lmap, feature) {
	if (feature && !feature._map) {
		feature.addTo(lmap);
	}
}

function createPopupButton(iconChr, label, className) {
	const el = document.createElement("button");
	el.className = className;

	const strong = document.createElement("strong");
	strong.appendChild( document.createTextNode(iconChr) );
	el.appendChild( strong );
	el.appendChild( document.createTextNode(label) );
	return el;
}

function createRemoveButton() {
	return createPopupButton("×", "Remove", "pbtn-remove");
}

function createHoleButton() {
	return createPopupButton("□", "Add hole", "pbtn-hole");
}

function get_sender_marker(e) {
	const sender = e?.target;
	if (sender?._owner_bitem) {
		return sender;
	}

	return null;
}

function is_near_zero(v) {
	return Math.abs(v) < 0.00001;
}

export { inEachArray, getEditorColor, is_outer, is_open, addToMapIf, createRemoveButton, createHoleButton, get_sender_marker, is_near_zero };